module.exports = __webpack_public_path__ + "img/1920x1080.e34bd180.png";